// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"237":"0675d58a","344":"744ff9a4","607":"4bda81ca","623":"f713e94e"}[chunkId] + ".css";
};